/**
 * LayoutSwitcher.tsx - Layout Selector UI for SectionNav
 * 
 * CHANGE HISTORY:
 * - 251115_1811 [current] danielbeer: Created layout switcher
 */

import React from 'react';
import type { LayoutSwitcherProps, SectionNavLayout } from './types';

const LAYOUT_ICONS: Record<SectionNavLayout, string> = {
  panes: '⊞',
  list: '☰',
  buttons: '▬',
  grid: '⊡',
  tabs: '⊟'
};

const LAYOUT_LABELS: Record<SectionNavLayout, string> = {
  panes: 'Panes',
  list: 'List',
  buttons: 'Buttons',
  grid: 'Grid',
  tabs: 'Tabs'
};

export const LayoutSwitcher: React.FC<LayoutSwitcherProps> = ({
  currentLayout,
  availableLayouts,
  onLayoutChange,
  className = ''
}) => {
  return (
    <div className={`layout-switcher ${className}`} role="toolbar" aria-label="Layout options">
      {availableLayouts.map((layout) => (
        <button
          key={layout}
          className={`layout-switcher__button ${currentLayout === layout ? 'layout-switcher__button--active' : ''}`}
          onClick={() => onLayoutChange(layout)}
          title={LAYOUT_LABELS[layout]}
          aria-label={`Switch to ${LAYOUT_LABELS[layout]} layout`}
          aria-pressed={currentLayout === layout}
        >
          <span aria-hidden="true">{LAYOUT_ICONS[layout]}</span>
          <span className="layout-switcher__label">{LAYOUT_LABELS[layout]}</span>
        </button>
      ))}
    </div>
  );
};

LayoutSwitcher.displayName = 'LayoutSwitcher';
